module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-container"
  }, [_c('section', {
    staticClass: "mobile"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "masthead-logo-mobile mobile"
  }, [_c('img', {
    attrs: {
      "src": 'static/img/common/logo.png'
    }
  })])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "about-section"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-1 text-center"
  }, [_c('h1', {
    staticClass: "h1-title",
    domProps: {
      "innerHTML": _vm._s(_vm.about.title)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "h3-subtitle h3-subtitle-padded",
    domProps: {
      "innerHTML": _vm._s(_vm.about.subtitle)
    }
  }), _vm._v(" "), _vm._l((_vm.about.body), function(p, index) {
    return _c('p', {
      staticClass: "page-paragraph",
      domProps: {
        "innerHTML": _vm._s(p)
      }
    })
  })], 2)])])]), _vm._v(" "), _c('section', {
    staticClass: "pure-text-centered",
    attrs: {
      "id": "clients"
    }
  }, [_c('client-section')], 1), _vm._v(" "), _c('section', [_c('contact-section')], 1), _vm._v(" "), _c('section', {
    staticClass: "section-joined-bottom"
  }, [_c('text-ticker', {
    attrs: {
      "page": "home"
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "section-joined-top"
  }, [_c('footer-image')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66fa6fdb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/About.vue
// module id = 147
// module chunks = 2